<!-- youtube-mobile-05 preview — YouTube Shorts, full-screen portrait image -->
<app-mobile-frame>
  <a class="yt-m-short d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <ng-container *ngIf="creativeImage; else missing">
      <img class="yt-m-short-blur" [src]="creativeImage" alt="" />
      <img class="yt-m-short-image" [src]="creativeImage" alt="" />
    </ng-container>
    <ng-template #missing>
      <div class="yt-m-short-missing">{{ missingDimensionLabel }}</div>
    </ng-template>

    <!-- START: Top channel bar -->
    <span class="yt-m-short-channel d-flex flex-row align-items-center gap-2">
      <img
        class="yt-m-short-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />
      <span class="yt-m-short-channel-text d-flex flex-column">
        <strong>{{ data.headlines[0] || "Your headline appears here" }}</strong>
        <small>Valamar</small>
      </span>
    </span>
    <i class="bi bi-info-circle-fill yt-m-short-info"></i>
    <!-- END: Top channel bar -->

    <app-youtube-shorts-logo class="yt-m-short-play"></app-youtube-shorts-logo>

    <!-- START: Action rail -->
    <span class="yt-m-short-rail d-flex flex-column align-items-center">
      <span *ngFor="let action of actions" class="yt-m-short-action d-flex flex-column align-items-center">
        <i class="bi" [ngClass]="action.icon"></i>
        <small>{{ action.label }}</small>
      </span>
      <i class="bi bi-three-dots yt-m-short-action"></i>
    </span>
    <!-- END: Action rail -->

    <!-- START: Bottom info -->
    <span class="yt-m-short-bottom d-flex flex-column">
      <span class="d-flex flex-row align-items-center gap-2">
        <img
          class="yt-m-short-logo"
          src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
          alt=""
        />
        <span class="yt-m-short-channel-text d-flex flex-column">
          <small>Valamar</small>
          <strong>Sponsored</strong>
        </span>
      </span>
      <span class="yt-m-short-desc">{{ data.descriptions[0] || "Your description appears here" }}</span>
    </span>
    <span class="yt-m-short-link"><i class="bi bi-link-45deg"></i></span>
    <span class="yt-m-short-sound"><i class="bi bi-soundwave"></i></span>
    <!-- END: Bottom info -->
  </a>

  <app-youtube-mobile-bottom-nav frameBottom></app-youtube-mobile-bottom-nav>
</app-mobile-frame>
